// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDeductibleDto
 */
export interface IDeductibleDto {
    /**
     * 
     * @type {number}
     * @memberof IDeductibleDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleDto
     */
    deductible_type?: IDeductibleDtoDeductibleTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleDto
     */
    accumulated?: number;
}

/**
* @export
* @enum {string}
*/
export enum IDeductibleDtoDeductibleTypeEnum {
    INDIVIDUAL_DEDUCTIBLE_MET = 'INDIVIDUAL_DEDUCTIBLE_MET',
    FAMILY_DEDUCTIBLE_MET = 'FAMILY_DEDUCTIBLE_MET'
}


/**
 * Check if a given object implements the IDeductibleDto interface.
 */
export function instanceOfIDeductibleDto(value: object): value is IDeductibleDto {
    return true;
}

export function IDeductibleDtoFromJSON(json: any): IDeductibleDto {
    return IDeductibleDtoFromJSONTyped(json, false);
}

export function IDeductibleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductibleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'deductible_type': json['deductible_type'] == null ? undefined : json['deductible_type'],
        'accumulated': json['accumulated'] == null ? undefined : json['accumulated'],
    };
}

export function IDeductibleDtoToJSON(json: any): IDeductibleDto {
    return IDeductibleDtoToJSONTyped(json, false);
}

export function IDeductibleDtoToJSONTyped(value?: IDeductibleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'deductible_type': value['deductible_type'],
        'accumulated': value['accumulated'],
    };
}

